export default class UserInquiryForm {
  public name: string = ''
  public body: string = ''

  toFormData() {
    const formData = new FormData()

    if (this.name) {
      formData.append('name', this.name)
    }
    if (this.body) {
      formData.append('body', this.body)
    }

    return formData
  }
}
